import React, {Component, Fragment} from "react";
import axios from 'axios'
import "./pixelog-view.css";

import Masonry from 'react-masonry-css';
import InfiniteScroll from 'react-infinite-scroll-component';
import ReactRouterPropTypes from 'react-router-prop-types';

import ReactHelmet from "../Header/ReactHelmet";
import MainPixelogCard from "../Main/MainPixelogCard";
import ViewPixelogCard from "./ViewPixelogCard";
import ViewPixelogReply from "./ViewPixelogReply";
import ViewPixelogProfile from "./ViewPixelogProfile";

import PixelogHeader from "../Header/PixelogHeader";

import AdSense from 'react-adsense-ad';

function shuffleArray(array) {
    let i = array.length - 1;
    for (; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        const temp = array[i];
        array[i] = array[j];
        array[j] = temp;
    }
    return array;
}

class ViewPixelogList extends Component {

    constructor(props) {
        super(props);

        this.state = {
            description: null,
            fps: null,
            frames: null,
            id: null,
            isFollow: null,
            isOwn: null,
            key: this.props.match.params.id,
            likes: null,
            name: null,
            nick: null,
            // profileKey: null,
            // profileKey_created_at: null,
            profileUrl: null,
            ispublic: null,
            session_nick: null,
            // session_profileKey: null,
            // session_profileKey_created_at: null,
            session_uid: null,
            session_profileUrl: null,
            tags: [],
            uid: null,
            deleted_at: null,
            reply: [],
            replyCnt: null,
            replyisLoading: true,
            created_at: null,
            type: null,

            //diary
            isdiary: null,
            diary_date: null,
            diary_whether: null,

            ItemList: [],
            piskelsCount: null,
            offset: 0,
            limit: 50,
            hasMore: true,
        }

        $(function () {
            $('[data-toggle="tooltip"]').tooltip();
        })

    }

    // 게시글 신고 버튼
    reportOnclick = () => {
        const {key} = this.state;
        var winUid = window.__pageInfo.uid;
        action_report(key, winUid, '1');
    }

    //좋아요 버튼
    likesOnclick = () => {
        const {key} = this.state;
        var winUid = window.__pageInfo.uid;
        ViewbtnLike(key, winUid);

        this.setState(prevState => ({
            likes: prevState.likes === '1' ? '0' : '1'
        }));
    }

    //뒤로가기 버튼
    goBackOnclick = () => {
        goBack();
    }

    //팔로우 버튼
    followOnclick = () => {
        const {uid} = this.state;
        var winUid = window.__pageInfo.uid;
        btnFollow(winUid, uid);
    }

    //정보수정 버튼
    editOnclick = () => {
        const {key, ispublic, isdiary} = this.state;
        action_piskel(key, ispublic, isdiary);
    }

    //그림일기 요일
    diaryDay = (diary_date) => {
        var week = ['일요일', '월요일', '화요일', '수요일', '목요일', '금요일', '토요일'];
        var dayOfWeek = week[new Date(diary_date).getDay()];
        return dayOfWeek;
    }

    //댓글등록 버튼
    btnAddOnclick = () => {
        const {key, session_uid, session_nick} = this.state;
        btnAdd(key, session_uid, 1, null, null, session_nick)
    }

    //관련태그
    loadDataTag = async () => {

        setTimeout(() => {

            const {key, offset, limit} = this.state;
            const {history, location} = this.props;

            let hasmore;

            axios
                .get(`/home/tags/${key}/${offset}/${limit}`)
                .then(({data}) => {

                    if (data.piskelsCount < 50) {
                        hasmore = false;
                    } else {
                        hasmore = true;
                    }

                    data.piskels = shuffleArray(data.piskels);


                    this.setState({
                        ItemList: [...this.state.ItemList, ...data.piskels],
                        offset: this.state.offset + this.state.limit,
                        limit: this.state.limit,
                        hasMore: hasmore,
                    }, () => {
                        history.replace(undefined, {...this.state});
                    });

                })
                .catch(errors => {
                    console.error(errors);
                });

        }, 100);

    }


    //최초 실행
    loadData = async () => {

        const {key} = this.state;
        const {history} = this.props;


        let form = new FormData()
        form.append('key', key)

        let hasmore;
        let one = `/pixelog/loadPixelogView/${key}`;
        let two = `/reply/load_reply`;
        let three = `/home/tags/${key}/0/50`;

        const requestOne = axios.get(one);
        const requestTwo = axios.post(two, form);
        const requestThree = axios.get(three);

        axios
            .all([requestOne, requestTwo, requestThree])
            .then(
                axios.spread((...responses) => {
                    const responseOne = responses[0];
                    const responseTwo = responses[1];
                    const requestThree = responses[2];
                    const {state} = this.props.location;
                    let likes;
                    if (state && state.likes) {
                        likes = state.likes;
                    } else {
                        likes = responseOne.data.likes;
                    }

                    //잘못된 경로
                    if (!responseOne.data.id) {
                        window.location.replace('/');
                    }

                    //비공개 또는 삭제일 경우 리디렉트
                    if (responseOne.data == "isPublic" || responseOne.data == "isDeleted") {
                        this.props.history.push("/");
                    }

                    let hasmore;
                    if (requestThree.data.piskelsCount < 50) {
                        hasmore = false;
                    } else {
                        hasmore = true;
                    }

                    this.setState({
                        description: htmlspecialchars_decode(responseOne.data.description, 'ENT_QUOTES').replace(/\\n/g, "\r\n"),
                        fps: responseOne.data.fps,
                        frames: responseOne.data.frames,
                        id: responseOne.data.id,
                        isFollow: responseOne.data.isFollow,
                        isOwn: responseOne.data.isOwn,
                        key: responseOne.data.key,
                        likes,
                        // likes: responseOne.data.likes,
                        name: htmlspecialchars_decode(responseOne.data.name, 'ENT_QUOTES'),
                        nick: responseOne.data.nick,
                        // profileKey: responseOne.data.profileKey,
                        // profileKey_created_at: responseOne.data.profileKey_created_at,
                        profileUrl: responseOne.data.profileUrl,
                        ispublic: responseOne.data.public,
                        session_nick: responseOne.data.session_nick,
                        // session_profileKey: responseOne.data.session_profileKey,
                        // session_profileKey_created_at: responseOne.data.session_profileKey_created_at,
                        session_profileUrl: responseOne.data.session_profileUrl,
                        session_uid: responseOne.data.session_uid,
                        tags: responseOne.data.tags,
                        uid: responseOne.data.uid,
                        deleted_at: responseOne.data.deleted_at,
                        type: responseOne.data.type,

                        //diary
                        isdiary: responseOne.data.diary,
                        diary_date: responseOne.data.diary_date,
                        diary_whether: responseOne.data.diary_whether,

                        reply: responseTwo.data.data,
                        replyCnt: responseTwo.data.cnt,
                        replyisLoading: false,
                        created_at: responseOne.data.created_at,

                        ItemList: [...this.state.ItemList, ...shuffleArray(requestThree.data.piskels)],
                        piskelsCount: requestThree.data.piskelsCount,
                        offset: 50, //50
                        limit: 50,  //50
                        hasMore: hasmore,

                    }, () => {
                        history.replace(undefined, {...this.state});
                    });
                })
            )
            .catch(errors => {
                // react on errors.
                console.error(errors);
            });
    }

    componentDidMount() {

        const {history, location} = this.props;


        window.onbeforeunload = (e) => {
            history.replace(undefined, undefined);
        };

        this.loadData();


        var viewMasonry = document.getElementsByClassName('view-masonry');

        if (viewMasonry[0] !== undefined) {

            var viewMasonryHeight = viewMasonry[0].getBoundingClientRect().top + $(window).scrollTop();

            var didScroll;
            var lastScrollTop = 0;
            var delta = 10;

            $(window).scroll(function (event) {

                didScroll = true;

                if (didScroll) {
                    hasScrolled();
                    didScroll = false;
                }

            });


            function hasScrolled() {
                var st = $(window).scrollTop();

                if (Math.abs(lastScrollTop - st) <= delta)
                    return;

                if (st > lastScrollTop && st > viewMasonryHeight) {
                    // $(".ad-view-container").addClass('ad-container-active');
                    // $(".col-md-auto").addClass('ad-masonry-active');


                } else {
                    if (st < viewMasonryHeight) {
                        // $(".ad-view-container").removeClass('ad-container-active');
                        // $(".col-md-auto").removeClass('ad-masonry-active');
                    }
                }

                lastScrollTop = st;
            }

        }

    }

    shouldComponentUpdate(nextProps, nextState) {

        if (this.state.key !== nextProps.match.params.id) {

            if (this.state == nextState) {

                const {history} = this.props;
                const key = nextProps.match.params.id;

                let form = new FormData()
                form.append('key', key)

                let one = `/pixelog/loadPixelogView/${key}`;
                let two = `/reply/load_reply`;
                let three = `/home/tags/${key}/0/50`;

                const requestOne = axios.get(one);
                const requestTwo = axios.post(two, form);
                const requestThree = axios.get(three);

                axios
                    .all([requestOne, requestTwo, requestThree])
                    .then(
                        axios.spread((...responses) => {
                            const responseOne = responses[0];
                            const responseTwo = responses[1];
                            const requestThree = responses[2];

                            //비공개 또는 삭제일 경우 리디렉트
                            if (responseOne.data == "isPublic" || responseOne.data == "isDeleted") {
                                this.props.history.push("/");
                            }

                            let hasmore;
                            if (requestThree.data.piskelsCount < 50) {
                                hasmore = false;
                            } else {
                                hasmore = true;
                            }

                            this.setState({
                                description: htmlspecialchars_decode(responseOne.data.description, 'ENT_QUOTES').replace(/\\n/g, "\r\n"),
                                fps: responseOne.data.fps,
                                frames: responseOne.data.frames,
                                id: responseOne.data.id,
                                isFollow: responseOne.data.isFollow,
                                isOwn: responseOne.data.isOwn,
                                key: responseOne.data.key,
                                likes: responseOne.data.likes,
                                name: htmlspecialchars_decode(responseOne.data.name, 'ENT_QUOTES'),
                                nick: responseOne.data.nick,
                                // profileKey: responseOne.data.profileKey,
                                // profileKey_created_at: responseOne.data.profileKey_created_at,
                                profileUrl: responseOne.data.profileUrl,
                                ispublic: responseOne.data.public,
                                session_nick: responseOne.data.session_nick,
                                // session_profileKey: responseOne.data.session_profileKey,
                                // session_profileKey_created_at: responseOne.data.session_profileKey_created_at,
                                session_profileUrl: responseOne.data.session_profileUrl,
                                session_uid: responseOne.data.session_uid,
                                tags: responseOne.data.tags,
                                uid: responseOne.data.uid,
                                deleted_at: responseOne.data.deleted_at,
                                reply: responseTwo.data.data,
                                replyCnt: responseTwo.data.cnt,
                                replyisLoading: false,
                                created_at: responseOne.data.created_at,
                                type: responseOne.data.type,

                                //diary
                                isdiary: responseOne.data.diary,
                                diary_date: responseOne.data.diary_date,
                                diary_whether: responseOne.data.diary_whether,

                                ItemList: shuffleArray(requestThree.data.piskels),
                                piskelsCount: requestThree.data.piskelsCount,
                                offset: 50, //50
                                limit: 50,  //50
                                hasMore: hasmore,
                            }, () => {
                                history.replace(undefined, {...this.state});
                            });

                        })
                    )
                    .catch(errors => {
                        // react on errors.
                        console.error(errors);
                    });

                return false;

            } else {
                return true;
            }

        } else {

            if (this.state == nextState) {
                return false;

            } else {
                return true;
            }
        }

    }//shouldComponentUpdate

    gf_Convert2ByteChar = (x_char) => {
        var x_2byteChar = "";

        for (var i = 0, l = x_char.length; i < l; i++) {

            var c = x_char[i].charCodeAt(0);

            if (32 <= c && c <= 126) {

                if (c == 32) {
                    x_2byteChar += "　";

                } else {

                    x_2byteChar += unescape("%u" + (c + 65248).toString(16));
                }

            } else {
                x_2byteChar += x_char[i];
            }
        }

        return x_2byteChar;
    }

    handleLikeChange = async (v) => {

        const {history} = this.props;
        const targetItemId = v.id; // 업데이트하려는 항목의 id

        if (Array.isArray(this.state.ItemList)) {
            const updatedItemList = this.state.ItemList.map(item => {
                if (item.id === targetItemId) {
                    return {...item, likes: v.likes};
                }
                return item; // 변경하지 않을 항목은 그대로 반환
            });

            this.setState({ItemList: updatedItemList}, () => {
                history.replace(undefined, {...this.state});
            });
        }
    }

    render() {

        const {
            description, fps, frames, id, isFollow, isOwn, key, likes, name, nick, ispublic, session_nick,
            session_uid, profileUrl, session_profileUrl,
            tags, uid, deleted_at, reply, replyCnt, replyisLoading, created_at,
            ItemList, piskelsCount, offset, limit, hasMore,
            isdiary, diary_whether, diary_date, type
        } = this.state;

        const {history, location} = this.props;

        // if(session_profileKey_created_at !== undefined && session_profileKey_created_at !== null){
        //   var sessionYear = session_profileKey_created_at.substring(2,4);
        //   var sessionMonth = session_profileKey_created_at.substring(5,7);
        //   var sessionDay = session_profileKey_created_at.substring(8,10);
        //   if(type == 1){ // ai 이미지 경로
        //       var sessionSrc = `/outputs/txt2img/20${sessionYear}-${sessionMonth}-${sessionDay}/${session_profileKey}.png`;
        //   }else {
        //       var sessionSrc = `/upload/${sessionYear}/${sessionMonth}/${sessionDay}/${session_profileKey}.png`;
        //   }
        //
        // }
        //
        // if(profileKey_created_at !== undefined && profileKey_created_at !== null){
        //   var profileYear = profileKey_created_at.substring(2,4);
        //   var profileMonth = profileKey_created_at.substring(5,7);
        //   var profileDay = profileKey_created_at.substring(8,10);
        //   if(type == 1){ // ai 이미지 경로
        //       var profileSrc = `/outputs/txt2img/20${profileYear}-${profileMonth}-${profileDay}/${profileKey}.png`;
        //   }else{
        //       var profileSrc = `/upload/${profileYear}/${profileMonth}/${profileDay}/${profileKey}.png`;
        //   }
        // }

        //날씨 아이콘
        var whetherClass = '';
        if (diary_whether == 1) {
            whetherClass = 'fa-sun text-warning';
        } else if (diary_whether == 2) {
            whetherClass = 'fa-cloud text-info';
        } else if (diary_whether == 3) {
            whetherClass = 'fa-umbrella text-primary';
        } else if (diary_whether == 4) {
            whetherClass = 'fa-snowflake text-info';
        } else if (diary_whether == 5) {
            whetherClass = 'fa-moon text-warning';
        } else if (diary_whether == 6) {
            whetherClass = 'fa-wind text-info';
        } else if (diary_whether == 7) {
            whetherClass = 'fa-bolt text-warning';
        } else if (diary_whether == 8) {
            whetherClass = 'fa-temperature-low text-primary';
        } else if (diary_whether == 9) {
            whetherClass = 'fa-temperature-high text-danger';
        }

        //팔로우 상태 셋팅
        var followClass = '';
        var followText = '';

        if (isFollow == 'Y') {
            followClass = "btn-outline-primary";
            followText = "팔로잉";

        } else {
            followClass = "btn-primary";
            followText = "팔로우";
        }

        //좋아요 클래스 셋팅
        let likes_class = '';

        //좋아요 셋팅 로그인유저
        if (likes !== undefined) {
            likes_class = this.state.likes === '1' ? 'view-likes-icon' : 'view-likes-no-icon';
            //비로그인 유저
        } else {
            likes_class = 'view-likes-no-icon';
        }

        const ptagsArray = tags.ptags || [];
        const ntagsArray = tags.ntags || [];
        const tagsArray = tags.tags || [];
        const tagsList = tagsArray.map((tag, index) => (
            <a className="tag-list text-decoration-none" key={index}
                href={`/search/tag=${encodeURIComponent(tag.tags)}`}>
                <span className="badge bg-primary bg-gradient-pixelog" style={{"fontWeight": "500 !important"}}>
                    {htmlspecialchars_decode(tag.tags, 'ENT_QUOTES')}
                </span>
            </a>
        ));

        const ptagsList = ptagsArray.map((tag, index) => (
            <a className="tag-list text-decoration-none" key={index}
               href={`/search/tag=${encodeURIComponent(tag.ptags)}`}>
                <span className="badge bg-primary" style={{"fontWeight": "500 !important"}}>
                    {htmlspecialchars_decode(tag.ptags, 'ENT_QUOTES')}
                </span>
            </a>
        ));

        const ntagsList = ntagsArray.map((tag, index) => (
            <a className="tag-list text-decoration-none" key={index}
               href={`/search/tag=${encodeURIComponent(tag.ntags)}`}>
                <span className="badge bg-warning" style={{"fontWeight": "500 !important"}}>
                    {htmlspecialchars_decode(tag.ntags, 'ENT_QUOTES')}
                </span>
            </a>
        ));

        let winUid = window.__pageInfo.uid;
        let osName = window.__pageInfo.osName;
        let isWeb = window.__pageInfo.isWeb;

        if(created_at != null){
            var year = created_at.substring(2,4);
            var month = created_at.substring(5,7);
            var day = created_at.substring(8,10);
            // ai 이미지경로
            if(type == 1){
                var imgSrc = `https://www.pixelog.gg/outputs/txt2img/20${year}-${month}-${day}/${key}${frames > 1 ? '.gif' : '.png'}`;
            }else{
                var imgSrc = `https://www.pixelog.gg/upload/${year}/${month}/${day}/${key}${frames > 1 ? '.gif' : '.png'}`;
            }
        }

        //downloadClick
        const downloadClick = (event) => {
            event.preventDefault();
            window.ReactNativeWebView.postMessage(JSON.stringify({
                status: 'downloadUrl',
                data: imgSrc,
            }));
        };

        //동일태그 더보기
        const piskelsList = ItemList.map(
            (itemdata, id) => (
                <MainPixelogCard
                    key={`t` + itemdata.id} //
                    id={itemdata.id}
                    dataKey={itemdata.key} //
                    uid={itemdata.uid} //
                    fps={itemdata.fps} //
                    frames={itemdata.frames} //
                    nick={itemdata.nick} //
                    winUid={winUid}
                    likes={itemdata.likes} //
                    created_at={itemdata.created_at}
                    type={itemdata.type}
                    onLikeChange={this.handleLikeChange}
                />
            )
        );

        const ViewCard = (
            <ViewPixelogCard
                key={id}
                dataKey={key} //
                frames={frames} //
                created_at={created_at}
                type={type}
            />
        );

        const ViewReply = (
            <ViewPixelogReply
                key={key}
                reply={reply} //
                replyCnt={replyCnt} //
                session_uid={session_uid}
                //session_profileKey={session_profileKey}
                session_profileUrl={session_profileUrl}
                session_nick={session_nick}
                replyisLoading={replyisLoading}
                datakey={key}
                type={type}
            />
        );

        const ViewProfile = (
            <ViewPixelogProfile
                key={uid}
                profileUrl={profileUrl}
                // profileKey={profileKey}
                // profileSrc={profileSrc}
            />
        );

        const breakpointColumnsObj = {
            default: 2,
            5039: 19,
            4787: 18,
            4535: 17,
            4283: 16,
            4031: 15,
            3779: 14,
            3527: 13,
            3275: 12,
            3023: 11,
            2771: 10,
            2519: 9,
            2267: 8,
            2015: 7,
            1763: 6,
            1511: 5,
            1199: 4,
            899: 3,
            699: 2, //699 까지 2개
        };


        return (
            <Fragment>
                <PixelogHeader history={this.props.history}/>
                <ReactHelmet title={`${name} - PIXELOG.GG`}/>
                {/*  그림일기  */}
                {isdiary == '1' ?
                    (
                        <Fragment>

                            {/* 그림일기 뷰 상단 광고 PC - wide */}
                            {isWeb &&
                                (
                                    <div className='d-none d-wide-block ad-view-conatainer'>
                                        <div className='ad-view'>
                                            <AdSense.Google
                                                className=''
                                                client='ca-pub-9216699597615631'
                                                slot='9432519739'
                                                style={{display: 'flex', height: '90px', width: '728px'}}
                                                format=''
                                            />
                                        </div>
                                    </div>
                                )
                            }

                            <div className="d-flex justify-content-center">
                                <div className="gridCentered clearfix">
                                    {/* 그림일기 뷰 상단 광고 모바일 */}
                                    <div className='d-block d-small-none ad-view-conatainer'>
                                        <div className='ad-view'>
                                            <AdSense.Google
                                                className=''
                                                client='ca-pub-9216699597615631'
                                                slot='9432519739'
                                                style={{display: 'flex', height: '100px', width: '320px'}}
                                                format=''
                                            />
                                        </div>
                                    </div>

                                    <div className="view-shadow bg-white rounded p-sm-3">
                                        <div className="row m-0">
                                            <div className="col-12 col-lg-6 p-0" style={{"height": "100%"}}>
                                                <div className="card-area position-relative" style={{"backgroundImage": "none"}}>
                                                    <span id={`id${key}`} onClick={this.likesOnclick} className={`cursor-pointer ${likes_class}`}>
                                                        <svg width="1.5em" height="1.5em" viewBox="0 0 16 16" className="bi bi-heart-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314z"/></svg>
                                                    </span>
                                                    {type !== '1' ?
                                                        (
                                                            <a className="d-flex tag-list text-decoration-none" href={`/pixelog/edit/${key}`}>
                                                                <span className="badge bg-primary badge-pixelog bg-gradient-pixelog">
                                                                PIXELOG
                                                                </span>
                                                            </a>
                                                        ) :
                                                        (
                                                            <span className="badge bg-success badge-pixelog bg-gradient">
                                                                PIXELOG
                                                            </span>
                                                        )
                                                    }
                                                    {osName === 'iOS' || !isWeb ?
                                                        (
                                                            <span className="view-likes-no-icon" style={{"right":"50px"}} onClick={downloadClick}>
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className="bi bi-download" viewBox="0 0 16 16">
                                                                    <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5"/>
                                                                    <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
                                                                </svg>
                                                            </span>
                                                        ):
                                                        (
                                                            <a className="view-likes-no-icon" style={{"right":"50px"}} href={`${imgSrc}`} target="_blank" download={`${key}${frames > 0 ? '.gif' : '.png'}`}>
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className="bi bi-download" viewBox="0 0 16 16">
                                                                    <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5"/>
                                                                    <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
                                                                </svg>
                                                            </a>
                                                        )
                                                    }
                                                    <div id={`sp${key}`} className="view-likes-spinner d-none spinner-border text-primary" role="status"></div>
                                                    {/*  메인 그림  */}
                                                    {ViewCard}
                                                </div>

                                                {/*  버튼 모음  */}
                                                {uid == session_uid &&
                                                    (
                                                        <div className="button-area mt-2 ms-2 ms-sm-0 text-start">
                                                            <a className="btn btn-sm btn-primary" href={`/user/${uid}`}>목록</a>
                                                            {deleted_at == null ?
                                                                (
                                                                    <Fragment>
                                                                        <button onClick={this.editOnclick} className="btn btn-sm btn-primary ms-1">정보 수정</button>
                                                                        {type !== '1' ? (
                                                                            <Fragment>
                                                                                <a className="btn btn-sm btn-primary ms-1" href={`/pixelog/edit/${key}`}>작품 수정</a>
                                                                                <a className="btn btn-sm btn-primary ms-1" href={`/pixelog/clone/${key}`}>복사</a>
                                                                            </Fragment>
                                                                        ) : null}
                                                                        <a className="btn btn-sm btn-danger ms-1" href={`/pixelog/delete/${key}`}>삭제</a>
                                                                    </Fragment>
                                                                )
                                                                :
                                                                (
                                                                    <Fragment>
                                                                        <a className="btn btn-sm btn-primary ms-1" href={`/pixelog/restore/${key}`}>복구</a>
                                                                        <a id="destoryModal" className="btn btn-sm btn-danger text-white ms-1" data-toggle="modal" data-id={key} href="#destroy_info">파괴</a>
                                                                    </Fragment>
                                                                )
                                                            }
                                                        </div>
                                                    )
                                                }
                                            </div>

                                            <div className="col-12 col-lg-6 p-0 mt-2 mt-lg-0 text-start diary-right-section">
                                                <div className="align-top position-relative">
                                                    {/*  제목  */}
                                                    <div style={{"maxWidth": "90%", "display": " inline-flex"}}>
                                                        {ispublic == "0" &&
                                                            (
                                                                <svg width="1em" height="1em" viewBox="0 0 16 16" className="pixelog-view-name bi bi-lock-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M2.5 9a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-7a2 2 0 0 1-2-2V9z"/>
                                                                    <path fillRule="evenodd" d="M4.5 4a3.5 3.5 0 1 1 7 0v3h-1V4a2.5 2.5 0 0 0-5 0v3h-1V4z"/>
                                                                </svg>
                                                            )
                                                        }
                                                        <div id={`name${key}`} className="pixelog-view-name d-inline-block text-truncate">{name}</div>
                                                    </div>
                                                    {/*  뒤로가기  */}
                                                    <span className="float-end cursor-pointer text-primary bg-gradient" onClick={this.goBackOnclick} style={{"marginTop": "5px"}}>
                                                        <svg width="1.5em" height="1.5em" viewBox="0 0 16 16" className="bi bi-arrow-left-square-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6.354 10.646a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L6.207 7.5H11a.5.5 0 0 1 0 1H6.207l2.147 2.146z"/></svg>
                                                    </span>
                                                    {/*  날짜  */}
                                                    <div className="clearfix"></div>
                                                    <h6 className="float-end mt-2">
                                                        <span>{diary_date} {this.diaryDay(diary_date)}
                                                        {/* 날씨 */}
                                                        <i className={`fas ${whetherClass} ms-2`}></i>
                                                        </span>
                                                    </h6>
                                                    <div className="clearfix"></div>
                                                    {/*  그림일기 내용  */}
                                                    <div className="my-4 mx-auto diary-textarea-container">
                                                        <div id={`description${key}`} className="diary-textarea">
                                                            {description ? (
                                                                this.gf_Convert2ByteChar(description)
                                                            ) : (
                                                                this.gf_Convert2ByteChar("내용을 입력해 주세요.")
                                                            )}
                                                        </div>
                                                    </div>
                                                    {/*  태그  */}
                                                    <div className="text-truncate">
                                                        {tagsList}{ptagsList}{ntagsList}
                                                        {/* 신고 */}
                                                        {/*<div className={'text-secondary cursor-pointer float-end'} onClick={this.reportOnclick}>신고</div>*/}
                                                    </div>

                                                    {/*  프로필이미지, 닉네임, 팔로우  */}
                                                    <div className="mt-2">
                                                        <a className="text-decoration-none card-preview-link" href={`/user/${uid}`}>
                                                        <span id="profile_area" className="card-follow-container d-inline-block align-middle position-relative">
                                                        {ViewProfile}
                                                        <div className="pixelog-img-profile-follow rounded-circle text-center align-middle"></div>
                                                        </span>
                                                        <span className="card-follow-body d-inline-block align-middle">
                                                            <div className="text-truncate text-dark mobile-title ms-1">{nick}</div>
                                                        </span>
                                                        </a>
                                                        {
                                                            isOwn == 'false' &&
                                                            (
                                                                <div id="btnFollow" className={`float-end btn btn-sm ${followClass} bg-gradient`} onClick={this.followOnclick} style={{"minWidth": "68px"}}>
                                                                    <div id="btnFollowSpin" className="spinner-border d-none spinner-border-sm" role="status"></div>
                                                                    <div id="btnFollowText">{followText}</div>
                                                                </div>
                                                            )
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/*  댓글내용  */}
                                        <div className="text-start mt-3 pb-3 px-3 p-sm-0">
                                            <ul className="nav nav-tabs mt-3 navbar ">
                                                <li className="nav-item">
                                                    <span className="nav-link active" href="#">댓글 <span id="reply_cnt" className="badge bg-secondary">{replyCnt}</span></span>
                                                </li>
                                                <li className={'text-secondary cursor-pointer'} onClick={this.reportOnclick}>신고</li>
                                            </ul>

                                            {ViewReply}
                                            {/*  로그인 해야지 댓글창 보임 -> 삭제  */}
                                            {/*  댓글입력  */}
                                            <Fragment>
                                                <div className="input-group mb-3">
                                                    {/*  댓글프로필  */}
                                                    <div className="input-group-prepend me-2">
                                                        <span className="card-preview-link">
                                                            <span className="card-follow-container d-inline-block align-middle position-relative">
                                                            {session_profileUrl !== null
                                                                ?
                                                                (
                                                                    <a className="text-decoration-none" href={`/user/${session_uid}`}>
                                                                        <img className="img-follow rounded-circle" src={session_profileUrl}/>
                                                                        <div className="pixelog-img-profile-follow rounded-circle text-center align-middle"></div>
                                                                    </a>
                                                                )
                                                                :
                                                                (
                                                                    <img className="img-follow-null rounded-circle" src="/img/pixelog-profile.png"/>
                                                                )
                                                            }
                                                            </span>
                                                        </span>
                                                    </div>
                                                    <input id="reply_input" type="text" className="form-control" placeholder="댓글 추가" autoComplete="off"/>
                                                </div>
                                                <div id="reply_input_button" className="clearfix text-end d-none">
                                                    <button id="reply_cancel" className="btn btn-sm btn-primary me-2">취소</button>
                                                    <button id="reply_submit" onClick={this.btnAddOnclick} className="btn btn-sm btn-primary disabled cursor-default">완료</button>
                                                </div>
                                            </Fragment>
                                        </div>
                                    </div>

                                    <div className="d-none d-wide-block mt-2"></div>

                                    {/* 그림일기 뷰 중단 광고 모바일 */}
                                    <div className='d-block d-small-none ad-view-conatainer mb-5'>
                                        <div className='ad-view'>
                                            <AdSense.Google
                                                className=''
                                                client='ca-pub-9216699597615631'
                                                slot='6233363524'
                                                style={{display: 'flex', height: '100px', width: '320px'}}
                                                format=''
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* 그림일기 뷰 중단 광고 PC - wide */}
                            {isWeb &&
                                (
                                    <div className='d-none d-wide-block ad-view-conatainer mb-5'>
                                        <div className='ad-view'>
                                            <AdSense.Google
                                                className=''
                                                client='ca-pub-9216699597615631'
                                                slot='6233363524'
                                                style={{display: 'flex', height: '90px', width: '728px'}}
                                                format=''
                                            />
                                        </div>
                                    </div>
                                )
                            }
                        </Fragment>
                    )
                    :
                    (
                        /*  픽셀아트  */
                        <Fragment>
                            {/* 픽셀아트 뷰 상단 광고 PC - wide */}
                            {isWeb &&
                                (
                                <div className='d-none d-wide-block ad-view-conatainer'>
                                    <div className='ad-view'>
                                        <AdSense.Google
                                            className=''
                                            client='ca-pub-9216699597615631'
                                            slot='8073908860'
                                            style={{display: 'flex', width: '728px', height: '90px'}}
                                            format=''
                                        />
                                    </div>
                                </div>
                                )
                            }

                            <div className="d-flex justify-content-center">
                                <div className="gridCentered clearfix">
                                    {/* 픽셀아트 뷰 상단 광고 모바일 */}
                                    <div className='d-block d-small-none ad-view-conatainer'>
                                        <div className='ad-view'>
                                            <AdSense.Google
                                                className=''
                                                client='ca-pub-9216699597615631'
                                                slot='8073908860'
                                                style={{display: 'flex', width: '320px', height: '100px'}}
                                                format=''
                                            />
                                        </div>
                                    </div>

                                    <div className="view-shadow bg-white rounded p-sm-3">
                                        <div className="row m-0">
                                            <div className="col-12 col-lg-6 p-0" style={{"height": "100%"}}>
                                                <div className="card-area position-relative">
                                                    <span id={`id${key}`} onClick={this.likesOnclick} likes={`${likes}`} className={`cursor-pointer ${likes_class}`}>
                                                        <svg width="1.5em" height="1.5em" viewBox="0 0 16 16" className="bi bi-heart-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314z"/></svg>
                                                    </span>
                                                    {type !== '1' ?
                                                        (
                                                            <a className="d-flex tag-list text-decoration-none" href={`/pixelog/edit/${key}`}>
                                                                <span className="badge bg-primary badge-pixelog bg-gradient-pixelog">
                                                                    PIXELOG
                                                                </span>
                                                            </a>
                                                        ) :
                                                        (
                                                            <span className="badge bg-success badge-pixelog bg-gradient">
                                                                PIXELOG
                                                            </span>
                                                        )
                                                    }

                                                    {osName === 'iOS' || !isWeb ?
                                                        (
                                                            <span className="view-likes-no-icon" style={{"right":"50px"}} onClick={downloadClick}>
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className="bi bi-download" viewBox="0 0 16 16">
                                                                    <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5"/>
                                                                    <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
                                                                </svg>
                                                            </span>
                                                        ):
                                                        (
                                                            <a className="view-likes-no-icon" style={{"right":"50px"}} href={`${imgSrc}`} target="_blank" download={`${key}${frames > 0 ? '.gif' : '.png'}`}>
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className="bi bi-download" viewBox="0 0 16 16">
                                                                    <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5"/>
                                                                    <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
                                                                </svg>
                                                            </a>
                                                        )
                                                    }
                                                    <div id={`sp${key}`} className="view-likes-spinner d-none spinner-border text-primary" role="status"></div>
                                                    {/*  메인 그림  */}
                                                    {ViewCard}
                                                </div>

                                                {/*  버튼 모음  */}
                                                {uid == session_uid &&
                                                    (
                                                        <div className="button-area mt-2 ms-2 ms-sm-0 text-start">
                                                            <a className="btn btn-sm btn-primary" href={`/user/${uid}`}>목록</a>
                                                            {deleted_at == null ?
                                                                (
                                                                    <Fragment>
                                                                        <button onClick={this.editOnclick} className="btn btn-sm btn-primary ms-1">정보 수정</button>
                                                                        {type !== '1' ? (
                                                                            <Fragment>
                                                                                <a className="btn btn-sm btn-primary ms-1" href={`/pixelog/edit/${key}`}>작품 수정</a>
                                                                                <a className="btn btn-sm btn-primary ms-1" href={`/pixelog/clone/${key}`}>복사</a>
                                                                            </Fragment>
                                                                        ) : null}
                                                                        <a className="btn btn-sm btn-danger ms-1" href={`/pixelog/delete/${key}`}>삭제</a>
                                                                    </Fragment>
                                                                )
                                                                :
                                                                (
                                                                    <Fragment>
                                                                        <a className="btn btn-sm btn-primary ms-1" href={`/pixelog/restore/${key}`}>복구</a>
                                                                        <a id="destoryModal" className="btn btn-sm btn-danger text-white ms-1" data-toggle="modal" data-id={key} href="#destroy_info">파괴</a>
                                                                    </Fragment>
                                                                )
                                                            }
                                                        </div>
                                                    )
                                                }
                                            </div>

                                            <div className="col-12 col-lg-6 mt-2 mt-lg-0 text-start pixelog-right-section">
                                                <div className="align-top position-relative">
                                                    {/*  제목  */}
                                                    <div style={{"maxWidth": "90%", "display": " inline-flex"}}>
                                                        {ispublic == "0" &&
                                                            (
                                                                <svg width="1em" height="1em" viewBox="0 0 16 16" className="pixelog-view-name bi bi-lock-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M2.5 9a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-7a2 2 0 0 1-2-2V9z"/>
                                                                    <path fillRule="evenodd" d="M4.5 4a3.5 3.5 0 1 1 7 0v3h-1V4a2.5 2.5 0 0 0-5 0v3h-1V4z"/>
                                                                </svg>
                                                            )
                                                        }
                                                        <div id={`name${key}`} className="pixelog-view-name d-inline-block text-truncate">{name}</div>
                                                    </div>
                                                    {/*  뒤로가기  */}
                                                    <span className="float-end cursor-pointer text-primary bg-gradient" onClick={this.goBackOnclick} style={{"marginTop": "5px"}}>
                                                        <svg width="1.5em" height="1.5em" viewBox="0 0 16 16" className="bi bi-arrow-left-square-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                            <path fillRule="evenodd" d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6.354 10.646a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L6.207 7.5H11a.5.5 0 0 1 0 1H6.207l2.147 2.146z"/>
                                                        </svg>
                                                    </span>
                                                    {/*  내용  */}
                                                    <div id={`description${key}`} className="text-truncate">{description}</div>
                                                    {/*  태그  */}
                                                    <div className="text-truncate">
                                                        {tagsList}{ptagsList}{ntagsList}
                                                        {/* 신고 */}
                                                        {/*<div className={'text-secondary cursor-pointer float-end'} onClick={this.reportOnclick}>신고</div>*/}
                                                    </div>
                                                    {/*  프로필이미지, 닉네임, 팔로우  */}
                                                    <div className="mt-2">
                                                        <a className="text-decoration-none card-preview-link" href={`/user/${uid}`}>
                                                            <span id="profile_area" className="card-follow-container d-inline-block align-middle position-relative">
                                                                {ViewProfile}
                                                            <div className="pixelog-img-profile-follow rounded-circle text-center align-middle"></div>
                                                            </span>
                                                            <span className="card-follow-body d-inline-block align-middle">
                                                                <div className="text-truncate text-dark mobile-title ms-1">{nick}</div>
                                                            </span>
                                                        </a>

                                                        {isOwn == 'false' &&
                                                            (
                                                                <div id="btnFollow" className={`float-end btn btn-sm ${followClass} bg-gradient`} onClick={this.followOnclick} style={{"minWidth": "68px"}}>
                                                                    <div id="btnFollowSpin" className="spinner-border d-none spinner-border-sm" role="status"></div>
                                                                    <div id="btnFollowText">{followText}</div>
                                                                </div>
                                                            )
                                                        }
                                                    </div>

                                                    {/*  댓글내용  */}
                                                    <ul className="nav nav-tabs mt-3 navbar" style={{ marginTop: '1rem !important'}}>
                                                        <li className="nav-item">
                                                            <span className="nav-link active" href="#">댓글 <span id="reply_cnt" className="badge bg-secondary">{replyCnt}</span></span>
                                                        </li>
                                                        <li className={'text-secondary cursor-pointer'} onClick={this.reportOnclick}>신고</li>
                                                    </ul>

                                                    {ViewReply}
                                                    {/*  로그인 해야지 댓글창 보임 -> 삭제  */}
                                                    {/*  댓글입력  */}
                                                    <Fragment>
                                                        <div className="input-group mb-3">
                                                            {/*  댓글프로필  */}
                                                            <div className="input-group-prepend me-2">
                                                                <span className="card-preview-link">
                                                                    <span className="card-follow-container d-inline-block align-middle position-relative">
                                                                        {session_profileUrl !== null ?
                                                                            (
                                                                                <a className="text-decoration-none" href={`/user/${session_uid}`}>
                                                                                    <img className="img-follow rounded-circle" src={session_profileUrl}/>
                                                                                    <div className="pixelog-img-profile-follow rounded-circle text-center align-middle"></div>
                                                                                </a>
                                                                            )
                                                                            :
                                                                            (
                                                                              <img className="img-follow-null rounded-circle" src="/img/pixelog-profile.png"/>
                                                                            )
                                                                        }
                                                                  </span>
                                                                 </span>
                                                            </div>
                                                            <input id="reply_input" type="text" className="form-control" placeholder="댓글 추가" autoComplete="off"/>
                                                        </div>

                                                        <div id="reply_input_button" className="clearfix text-end d-none">
                                                            <button id="reply_cancel" className="btn btn-sm btn-primary me-2">취소</button>
                                                            <button id="reply_submit" onClick={this.btnAddOnclick} className="btn btn-sm btn-primary disabled cursor-default">완료</button>
                                                        </div>
                                                    </Fragment>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="d-none d-wide-block mt-2"></div>

                                    {/* 픽셀아트 뷰 중단 광고 모바일 */}
                                    <div className='d-block d-small-none ad-view-conatainer mb-5'>
                                        <div className='ad-view'>
                                            <AdSense.Google
                                                className=''
                                                client='ca-pub-9216699597615631'
                                                slot='7878467740'
                                                style={{display: 'flex', width: '320px', height: '100px'}}
                                                format=''
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* 픽셀아트 뷰 중단 광고 PC - wide */}
                            {isWeb &&
                                (
                                <div className='d-none d-wide-block ad-view-conatainer mb-5'>
                                    <div className='ad-view'>
                                        <AdSense.Google
                                            className=''
                                            client='ca-pub-9216699597615631'
                                            slot='7878467740'
                                            style={{display: 'flex', width: '728px', height: '90px'}}
                                            format=''
                                        />
                                    </div>
                                </div>
                                )
                            }
                        </Fragment>
                    )
                }

                {/*  관련태그  */}
                {piskelsCount == 0 ?
                    (
                        <div className="w-100 alert alert-white text-center" role="alert">
                            <h5>동일 태그 작품이 없습니다.</h5>
                        </div>
                    )
                    :
                    (
                        <div className="w-100 alert alert-white text-center">
                            <h5>동일 태그 더보기</h5>
                        </div>
                    )
                }

                <InfiniteScroll
                    dataLength={this.state.ItemList.length} //This is important field to render the next data
                    next={this.loadDataTag}
                    style={{overflow: 'visible'}}
                    hasMore={this.state.hasMore}
                    loader={
                        <div className="spin-container pb-3">
                            <div className="spinner-border" style={{"width": "3rem", "height": "3rem"}} role="status"></div>
                        </div>
                    }
                >
                    <div className="row m-0 justify-content-sm-center mt-3">
                        <div className="col-12 col-sm-auto m-0 p-0">
                            <Masonry
                                breakpointCols={breakpointColumnsObj}
                                className="my-masonry-grid grid row gx-2"
                                columnClassName=""
                            >
                                {piskelsList}
                            </Masonry>
                        </div>

                        <div className="col-12 col-sm-3 col-xl-4 m-0 col-ad-list pe-0 ps-ad">
                            {isWeb &&
                                (
                                    <Fragment>
                                        {/*-------------- ------------ sm -------------- ------------*/}
                                        {/* 뷰 리스트 광고1 PC 125 X 125 (그림일기, 픽셀아트 공통) */}
                                        <div className="card ad-list-container-small d-none d-sm-block d-xl-none">
                                            <div className="card-body p-0">
                                                <h5 className="ad-card-title text-start">광고</h5>
                                                <div className="ad-list ad-list-1">
                                                    <AdSense.Google
                                                        className=''
                                                        client='ca-pub-9216699597615631'
                                                        slot='3762642691'
                                                        style={{display: 'flex', width: '125px', height: '125px'}}
                                                        format=''
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        {/* 뷰 리스트 광고2 PC 120 X 600 (그림일기, 픽셀아트 공통) */}
                                        <div className="card ad-list-container d-none d-sm-block d-md-none">
                                            <div className="card-body p-0">
                                                <h5 className="ad-card-title text-start">광고</h5>
                                                <div className="ad-list ad-list-2">
                                                    <AdSense.Google
                                                        className=''
                                                        client='ca-pub-9216699597615631'
                                                        slot='4158104807'
                                                        style={{display: 'flex', width: '120px', height: '600px'}}
                                                        format=''
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        {/*-------------- ------------ md -------------- ------------*/}
                                        {/* 뷰 리스트 광고2 PC 160 X 600 (그림일기, 픽셀아트 공통) */}
                                        <div className="card ad-list-container d-none d-md-block d-xl-none">
                                            <div className="card-body p-0">
                                                <h5 className="ad-card-title text-start">광고</h5>
                                                <div className="ad-list ad-list-2">
                                                    <AdSense.Google
                                                        className=''
                                                        client='ca-pub-9216699597615631'
                                                        slot='8001756675'
                                                        style={{display: 'flex', width: '160px', height: '600px'}}
                                                        format=''
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        {/*-------------- ------------ xl -------------- ------------*/}
                                        {/* 뷰 리스트 광고2 PC 300 X 600 (그림일기, 픽셀아트 공통) */}
                                        <div className="card ad-list-container d-none d-xl-block">
                                            <div className="card-body p-0">
                                                <h5 className="ad-card-title text-start">광고</h5>
                                                <div className="ad-list ad-list-2">
                                                    <AdSense.Google
                                                        className=''
                                                        client='ca-pub-9216699597615631'
                                                        slot='2353844173'
                                                        style={{display: 'flex', width: '300px', height: '600px'}}
                                                        format=''
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </Fragment>
                                )
                            }

                            {/* 뷰 하단 광고 모바일 (그림일기, 픽셀아트 공통) */}
                            <div className='d-block d-sm-none ad-view-conatainer' style={{"marginTop": "4rem"}}>
                                <div className='ad-view'>
                                    <AdSense.Google
                                        className=''
                                        client='ca-pub-9216699597615631'
                                        slot='6355888115'
                                        style={{display: 'flex', height: '100px', width: '320px'}}
                                        format=''
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </InfiniteScroll>
            </Fragment>
        );//return
    }//render

};//component

ViewPixelogList.propTypes = {
    history: ReactRouterPropTypes.history.isRequired,
    location: ReactRouterPropTypes.location.isRequired,
};

export default ViewPixelogList;